






























































































import Vue from "vue";
import ApiService from "../../services/ApiService";
import SingleParent from "@/modals/SingleParent.vue";
export default Vue.extend({
  data() {
    return {
      data: [],
      staffLabels: {
        1: "Head Teacher",
        2: "Teacher",
        3: "School Office",
        'HEAD_TEACHER': 'Head teacher',
        'TEACHER': 'Teacher',
        'SCHOOL_OFFICE': 'School Office',
      },
      name: "",
      email: "",
      type: "",
      loading: true,
    };
  },
  methods: {
    getStaff() {
      ApiService.generalApi.getSchoolStaff().then((resp) => {
        const data = resp.data;
        data.forEach((element) => {
          element.staff_type = this.staffLabels[element.staff_type];
        });
        this.loading = false;
        this.data = data;
      });
    },
    openParent(userId) {
      this.$modal.show(
        SingleParent,
        {
          options: {
            profilePicture: true,
          },
          userId,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: 700,
          adaptive: true,
          width: 1100,
          // pivotY: 0
        },
        {
          "before-close": this.beforeClose,
        }
      );
    },
    beforeClose() {
      this.getStaff();
    },
  },
  mounted() {
    this.getStaff();
  },
});
